module.exports = __webpack_public_path__ + "media/images/pencil-blue-line-dark-7c6fd292d70d8bd35388bbced30bb9e9.png";